import React, { useContext } from 'react'
import { DocumentContext } from '../contexts/DocumentContext';
import ProgressBar from 'react-bootstrap/ProgressBar';

export const UploaderProgressBar = () => {
    const [percentageUpload] = useContext(DocumentContext);
    return (
        <>
            {percentageUpload > 0 && (
                <>
                    <ProgressBar animated now={percentageUpload} label={`${percentageUpload}%`} />
                    <div className='row text-center d-block'>
                        <small>  Please wait, while file is being uploaded !</small>
                    </div>
                </>
            )}
        </>
    )
}
